import React from "react"
import * as Icon from "react-feather"

const physicianMenuConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/",
  },
  {
    id: "viewProvider",
    title: "View Provider",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/providerlist",
  },
  {
    id: "addProvider",
    title: "Add Provider",
    type: "item",
    icon: <Icon.UserPlus size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/addprovider",
  },
]

export default physicianMenuConfig
